// extracted by mini-css-extract-plugin
export default {"dialog__textField":"ChatNameEditDialog_dialog__textField__2YvBS","chatNameDialog":"ChatNameEditDialog_chatNameDialog__6Ct0l"};